/**
 * <s-sticky-atc> — discreet mobile "Add to bag" bar for the product page.
 * Shows once the main product form has scrolled above the viewport and hides
 * again when the form is back in view. Its button presses the real add-to-cart
 * button, so variant, quantity and cart behaviour stay owned by the product form.
 * The product form partial is swapped on variant change, so the main button is
 * looked up on every click instead of being cached.
 */
class StickyAtc extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const form = document.querySelector('s-product-form[data-product-form]');
    const button = this.querySelector('[data-sticky-atc-button]');
    if (!form || !button) return;

    button.addEventListener('click', () => {
      const main = form.querySelector('button[name="add"]');
      const usable = main && !main.disabled && main.getAttribute('aria-disabled') !== 'true';
      if (usable) {
        main.click();
      } else {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.inert = true;
    this.#observer.observe(form);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', StickyAtc);
}
